import { schema } from "normalizr";

const bookingSchema = new schema.Entity(
	"bookings",
	{},
	{ idAttribute: (value) => value.confirmationCode || "errorBooking" }
);

export default bookingSchema;
